import * as apifetch from './servicePoint';

export async function getSearchResultsNewsletter(value) {
  const term = encodeURIComponent(value);
  const isLocalApi = (process.env.REACT_APP_URL_API || '').includes('api.localhost');
  const urlEndpoint = isLocalApi
    ? '/newsletters/index.php?path=/search/' + term
    : '/v2/newsletters/search/' + term;

    return apifetch.servicePoint(urlEndpoint, 'GET');
}


export async function GetSearch(params) {
  let endpoint = "/search/search.php";

  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== "" && value != null) {
      query.set(key, value);
    }
  });

  const fullEndpoint =
    endpoint + "?" + query.toString();

  return apifetch.servicePoint(fullEndpoint, "GET");
}


export async function GetSearchFuzzy(params) {
  let endpoint = "/search/search.php";

  const query = new URLSearchParams();
  Object.entries({ ...params, fuzzy: "1" }).forEach(([key, value]) => {
    if (value !== "" && value != null) {
      query.set(key, value);
    }
  });

  const fullEndpoint =
    endpoint + "?" + query.toString();

  return apifetch.servicePoint(fullEndpoint, "GET");
}
